import * as Yup from "yup";

Yup.setLocale({
  mixed: {
    notType: ({ type }) => `Sadece rakam girebilirsiniz.`,
    default: () => "Hatalı Giriş",
    required: () => "Bu alan zorunlu",
  },
  number: {
    min: ({ min }) => ({ key: "field_too_short", values: { min } }),
    max: ({ max }) => ({ key: "field_too_big", values: { max } }),
  },
  string: {
    min: ({ min }) => `En az ${min} karakter olmalı`,
    max: ({ max }) => `En fazla ${max} karakter girebilirsiniz`,
    email: () => `Geçerli bir mail adresi girin.`,
    matches: () => `Karakter uyumsuzluğu.`,
  },
});

export default Yup;
